// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___21rMl","rightsReserved":"styles-module__rightsReserved___17oj9","links":"styles-module__links___13zUX","text":"styles-module__text___2hKXN"};